import { isEmpty } from 'lodash';
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import './AutomaticTransactionList.scss';

import ExpandedAutomaticTransaction from '../ExpandedAutomaticTransaction/ExpandedAutomaticTransaction';
import {
  showMoreAutoExchanges,
  showMoreRecurringPurchases as actionShowMoreRecurringPurchases,
  showMoreRecurringRedemptions,
  showMoreRMDs,
} from '../../../redux/modules/automaticInvestments/automaticInvestments.module';
import {
  getRecurringBuyFundsLength,
  getAutoExchangeFundsLength,
  getRecurringRedemptionFundsLength,
  getShowMoreRecurringBuyFunds,
  getShowMoreAutoExchangeFunds,
  getShowMoreRecurringRedemptionFunds,
  getRMDFundsLength,
  getShowMoreRMDFunds,
  getOWNRAutoMaxFunds,
  getAutoMaxPOAsFunds,
} from '../../../redux/modules/shoppingCart/shoppingCart.selectors';
import {
  IRA_AUTO_MAX,
  RECURRING_BUY,
  RECURRING_EXCHANGE,
  RECURRING_SELL,
  RMD,
} from '../../../settings/settings';
import Button from '../../Shared/Button/Button';
import If from '../../Shared/If/If';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import { getHasCollegeOnly } from '../../../redux/modules/productTypes/productType.selectors';
import { isAPP, isRAS } from '../../../utils/advice/advice-utility';
import AutoMaxGrouping from '../AutoMax/AutoMaxGrouping';
import { getUserHasAutoMaxPOAs } from '../../../redux/modules/automaticInvestments/automaticInvestments.selectors';

export class AutomaticTransactionList extends Component {
  toggleShow() {
    const { showMoreFunds, getShowMore, type } = this.props;
    if (getShowMore) {
      scrollElementIntoFullView(`transaction-group-${type}`, 15);
    }
    showMoreFunds(!getShowMore);
  }

  getAutomaticStepButtonClass(hasCollegeOnly, type, ownsIRAs) {
    if (hasCollegeOnly) {
      return 'automatic-transaction-list-add-new-college-button';
    } else {
      if (type !== IRA_AUTO_MAX || ownsIRAs) {
        return 'automatic-transaction-list-add-new-button';
      } else {
        return 'automatic-transaction-list-add-new-button-no-display';
      }
    }
  }

  render() {
    const {
      buttonText,
      funds,
      fundsLength,
      getShowMore,
      link,
      title,
      ownsIRAs,
      type,
      getHasCollegeOnly,
      autoMaxOwnedIRATransactions,
      autoMaxPOAIRATransactions,
      hasAutoMaxPOAs,
    } = this.props;
    return (
      <div className="automatic-transaction-list-container">
        <If
          test={
            (!funds?.length && funds.length === 0 && type !== IRA_AUTO_MAX) ||
            (type === IRA_AUTO_MAX &&
              autoMaxOwnedIRATransactions?.ownedFunds.length === 0)
          }
        >
          {type === IRA_AUTO_MAX &&
            hasAutoMaxPOAs &&
            ownsIRAs &&
            autoMaxOwnedIRATransactions?.ownedFunds.length ===
            (
              <div className="automatic-transaction-list-zero-state-no-border">
                You do not have {title} set up.
              </div>
            )}

          {type === IRA_AUTO_MAX && !hasAutoMaxPOAs && (
            <div className="automatic-transaction-list-zero-state">
              You do not have {title} set up.
            </div>
          )}
          {type !== IRA_AUTO_MAX && (
            <div className="automatic-transaction-list-zero-state">
              {type === RMD ? (
                <a
                  href={link}
                  className={'automatic-transaction-list-view-rmd'}
                >
                  View RMD Dashboard{' '}
                </a>
              ) : (
                `You do not have ${
                  getHasCollegeOnly ? title : `any ${title}s`
                } set up.`
              )}
            </div>
          )}
        </If>
        <If test={funds.length > 0 && type !== IRA_AUTO_MAX}>
          {funds.map((fund, i) => {
            return isMissingPershingAppData(fund) ? (
              <Fragment key={`${fund.agreementID}-${i}`}>
                <ExpandedAutomaticTransaction
                  type={type}
                  fund={fund}
                  hidden={!getShowMore && i > 1 && !getHasCollegeOnly}
                  failedToRetrieveData
                />
              </Fragment>
            ) : (
              <Fragment key={`${fund.agreementID}-${i}`}>
                <ExpandedAutomaticTransaction
                  type={type}
                  fund={fund}
                  hidden={!getShowMore && i > 1 && !getHasCollegeOnly}
                />
              </Fragment>
            );
          })}
        </If>
        <If test={type === IRA_AUTO_MAX && (ownsIRAs || hasAutoMaxPOAs)}>
          <AutoMaxGrouping
            autoMaxOwnedIRATransactions={autoMaxOwnedIRATransactions}
            autoMaxPOAIRATransactions={autoMaxPOAIRATransactions}
            type={type}
          />
        </If>
        <If test={type !== RMD && (type !== IRA_AUTO_MAX || ownsIRAs)}>
          <a href={link} title="link" aria-label="link">
            <Button
              id={`automatic-transaction-step-${type}-button`}
              className={`${this.getAutomaticStepButtonClass(
                getHasCollegeOnly,
                type,
                ownsIRAs
              )} college-branded-progress-button e2e-step-${type}-button`}
              buttonType="primary"
              type="button"
              disabled={false}
              onClick={() => {}}
            >
              {buttonText}
            </Button>
          </a>
        </If>
        <If
          test={fundsLength > 2 && type !== IRA_AUTO_MAX && !getHasCollegeOnly}
        >
          <div className="automatic-transaction-list-view-all-funds">
            <button
              className="e2e-view-all-funds automatic-transaction-list-clickable"
              onClick={() => this.toggleShow()}
            >
              {' '}
              {getShowMore ? 'View Less' : 'View All'}{' '}
            </button>
          </div>
        </If>
      </div>
    );
  }
}

// Note that pending transactions that failed at the record keeper
// still need to show up.  To differentiate between a pending and
// a failed retrieval, we'll check the bank info.  If there is none,
// then we know that it was a failed retrieval from Pershing
function isMissingPershingAppData(fund) {
  return (
    (isAPP(fund.productType) || isRAS(fund.productType)) &&
    !!fund.recordKeeperStatus &&
    fund.recordKeeperStatus.enumerationName === 'Fail' &&
    isEmpty(fund.bank)
  );
}

function mapStateToProps(state, ownprops) {
  const { type } = ownprops;
  return {
    getShowMore:
      type === RECURRING_BUY
        ? getShowMoreRecurringBuyFunds(state)
        : type === RECURRING_SELL
        ? getShowMoreRecurringRedemptionFunds(state)
        : type === RECURRING_EXCHANGE
        ? getShowMoreAutoExchangeFunds(state)
        : getShowMoreRMDFunds(state),
    fundsLength:
      type === RECURRING_BUY
        ? getRecurringBuyFundsLength(state)
        : type === RECURRING_SELL
        ? getRecurringRedemptionFundsLength(state)
        : type === RECURRING_EXCHANGE
        ? getAutoExchangeFundsLength(state)
        : getRMDFundsLength(state),
    getHasCollegeOnly: getHasCollegeOnly(state),
    autoMaxOwnedIRATransactions: getOWNRAutoMaxFunds(state),
    autoMaxPOAIRATransactions: getAutoMaxPOAsFunds(state),
    hasAutoMaxPOAs: getUserHasAutoMaxPOAs(state),
  };
}

const mapDispatchToProps = (dispatch, ownprops) =>
  bindActionCreators(
    {
      showMoreFunds:
        ownprops.type === RECURRING_BUY
          ? actionShowMoreRecurringPurchases
          : ownprops.type === RECURRING_SELL
          ? showMoreRecurringRedemptions
          : ownprops.type === RECURRING_EXCHANGE
          ? showMoreAutoExchanges
          : showMoreRMDs,
    },
    dispatch
  );

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  AutomaticTransactionList
);
